<template>
    <b-link @click.prevent="handleBookmark" class="bookmark">
        <b-icon
            :icon="`bookmark${isBookmarked ? '-fill' : ''}`"
            font-scale="1.5"
        ></b-icon>
    </b-link>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
    name: "Bookmark",
    props: {
        title: {
            type: String,
            default: document.title,
        },
        url: {
            type: String,
            default: location.href,
        },
    },
    setup(props) {
        const isBookmarked = ref(!!localStorage.getItem(props.title));

        const handleBookmark = () => {
            if (isBookmarked.value) {
                isBookmarked.value = false;

                localStorage.removeItem(props.title);
            } else {
                var browser = navigator.userAgent.toLowerCase();

                if (window.sidebar && window.sidebar.addPanel) {
                    // Firefox <23
                    window.sidebar.addPanel(props.title, props.url, "");

                    localStorage.setItem(props.title, props.url);
                } else if (window.external && "AddFavorite" in window.external) {
                    // Internet Explorer
                    window.external.AddFavorite(props.url, props.title);

                    localStorage.setItem(props.title, props.url);
                } else if (window.opera && window.print) {
                    // Opera <15 and Firefox >23
                    /**
                     * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
                     * The only thing needed is a `title` and a `rel="sidebar"`
                     * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
                     * we force the current URL
                     */
                    var elem = document.createElement("a");
                    elem.setAttribute("href", props.url);
                    elem.setAttribute("title", props.title);
                    elem.setAttribute("rel", "sidebar");
                    elem.click();

                    isBookmarked.value = true;

                    localStorage.setItem(props.title, props.url);
                } else {
                    // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D
                    if (!localStorage.getItem(props.title)) {
                        isBookmarked.value = true;

                        localStorage.setItem(props.title, props.url);

                        alert(
                            "You can add this page to your bookmarks by pressing " +
                                (browser.indexOf("mac") != -1 ? "Command/Cmd" : "CTRL") +
                                " + D on your keyboard."
                        );
                    }
                }
            }
        };

        return {
            isBookmarked,
            handleBookmark,
        };
    },
});
</script>
